import type { SuperHubProps } from '@routes/SuperHub';

import { useState } from 'react';

import useClassy from '@core/hooks/useClassy';
import { ConnectSuperHubStoreToRouter, InitializeSuperHubVersions } from '@core/store';
import { SuperHubContextProvider } from '@routes/SuperHub/components/Context';
import classes from '@routes/SuperHub/index.module.scss';
import DropdownPortalContext from '@ui/Dropdown/PortalContext';

/**
 * Renders read-only SuperHub UI for end users that should only be able to see
 * and read docs for main versions (i.e. not branches). This is the default view
 * for logged out or readonly users who should only be consuming documentation.
 */
export default function EndUserContainer({ children, versions }: SuperHubProps) {
  const bem = useClassy(classes, 'SuperHub');
  const [portalTarget, setPortalTarget] = useState<HTMLDivElement | null>(null);

  return (
    <SuperHubContextProvider>
      <InitializeSuperHubVersions initialVersions={versions}>
        <ConnectSuperHubStoreToRouter disableHashRoutes>
          <div ref={setPortalTarget} className={bem('&', 'rm-ReadMe')}>
            <DropdownPortalContext.Provider value={portalTarget}>{children}</DropdownPortalContext.Provider>
          </div>

          <div className="ModalWrapper" id="tutorialmodal-root" />
        </ConnectSuperHubStoreToRouter>
      </InitializeSuperHubVersions>
    </SuperHubContextProvider>
  );
}
